@if (groupedConversationSessions.length) {
    <h3 class="sessions-history-title">Conversation Sessions</h3>
    <div class="sessions-list">
        @for (group of groupedConversationSessions; track $index) {
            <div class="month-year-group">
                <p class="month-year-title body-sm-14-semibold">{{ group.monthYear }}</p>
                @for (session of group.sessions; track $index) {
                    <p class="session-title" (click)="openConversation(session.id)">
                        <span class="session-title-text">{{ session.title }}</span>
                    </p>
                }
            </div>
        }
    </div>
}
